import * as React from 'react';

interface IProps {
	timeoutMs: number;
	onFinished?: () => void;
}

const CountdownLoader = (props: IProps) => {
	const { timeoutMs, onFinished } = props;
	const timeToStart = 50;
	const [started, start] = React.useState(false);

	React.useEffect(() => {
		setTimeout(() => {
			start(true);
		}, timeToStart);
		setTimeout(() => {
			if (onFinished) {
				onFinished();
			}
		}, timeToStart + timeoutMs);
	}, []);

	return (
		<div className={'countdownLoader' + (started ? ' active' : '')}>
			<i style={{ transitionDuration: timeoutMs + 'ms' }} />
		</div>
	);
};

export { CountdownLoader };
